<div class="user-item-component orgbrain-style" [id]="'_chooserItem_' + item.email">
  <div class="flex !py-2 items-center">
    <orgbrain-letter-generic-avatar
      [size]="40"
      [firstname]="item.firstName"
      [lastname]="item.lastName"
      [initials]="item.initials"
      [logoUrl]="item.logoUrl"
    >
    </orgbrain-letter-generic-avatar>
    <div class="ml-2 flex flex-col text-left">
      <div class="text-sm">{{ item.firstName }} {{ item.lastName }}</div>
      <div class="text-sm text-orgbrain-gray">{{ item.email }}</div>
    </div>
  </div>
</div>
